<template>
  <modal
    name="quote-request-modal"
    width="100%"
    height="100%"
    :clickToClose="false"
  >
    <QuoteContainer @onBack="closeModal"/>
  </modal>
</template>

<script>

import QuoteContainer from './QuoteContainer.vue';

export default {
  props: {
    show: Boolean
  },
  components: {
    QuoteContainer
  },
  data() {
    return {
      isRequestSucceed: false
    }
  },
  watch: {
    show(open) {
      if (open) {
        this.$modal.show('quote-request-modal');
      }
    }
  },
  methods: {
    closeModal() {
      this.$modal.hide('quote-request-modal');
      this.$emit('onClose');
    }
  }
}

</script>

<style lang="scss" scoped>

@import '../common/variables';

.v--modal-overlay {
  z-index: 9999999999;
  ::v-deep(.v--modal-box) {
    padding: 0 !important;
  }
}

</style>